import { Link, LinkProps } from 'ia-react-core';
import { FC } from 'react';
import styled from 'styled-components';

export const StyledUl = styled.ul<{ isTermsOfUse: boolean }>`
 margin-top: 0px;
 line-height: 2.4;
 margin-bottom: 30px;
 padding-left: 0px;
 list-style: none;
 ${({ isTermsOfUse }) => isTermsOfUse === true && `
padding-top: 30px;
list-style: disc;
padding-left: 20px;
line-height: 1.5;
  `}
> li {
  a {
      text-decoration: none;
      font-weight: 600;
      flex-flow: wrap;
      font-size: 14px;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.59;
      letter-spacing: normal;
      color: ${({ theme }) => theme.colors.blue5};
      &:hover {
        text-decoration: underline;
      }
      &:active {
        color: ${({ theme }) => theme.colors.blue10};
        text-decoration: underline;
      }
    }

  }
`;

export const StyledDiv = styled.div`
font-weight: 600;
`;

export const StyledLink = styled<FC<LinkProps>>(Link)`
white-space: initial;
 &:focus {
   box-shadow: 0 0 3px 0 ${({ theme }) => theme.colors.lighter};  
  }
`;

export const StyledLi = styled.li<{ isSubItem: boolean }>`
font-size: 12px;
${({ isSubItem }) => isSubItem === true && `

padding-left: 20px;
  
  `}
`;
export const StyledSubDiv = styled.div`
  padding-left: 16px;
`;
